import { FC } from 'react';
import { LoaderSvg } from 'shared/icon';

interface IProps {
	size?: number;
	height?: number;
}

const Loader: FC<IProps> = ({ size = 35, height }) => {
	return (
		<div style={{ height: height || '600px' }}>
			<div className={'flex items-center justify-center w-full h-full'}>
				<LoaderSvg width={size} height={size} />
			</div>
		</div>
	);
};

export default Loader;
